import { ContextKindKey } from '@gonfalon/contexts/types';
import { List, Record } from '@gonfalon/immutable-shim/immutableShim';

type SegmentTargetProps = {
  values: List<string>;
  contextKind: string;
};
export class SegmentTarget extends Record<SegmentTargetProps>({
  values: List(),
  contextKind: '',
}) {
  getContextKind() {
    return this.contextKind || ContextKindKey.USER;
  }
}
